import React from "react";

const Stat_Normal_Distrib = () => {
  return (
    <div>
      <h1>Stat Normal Distrib.</h1>
    </div>
  );
};

export default Stat_Normal_Distrib;
